export default __webpack_public_path__ + "static/media/face.5a0d1c2f.png";